import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { SliceQuery, SliceUpdateQuery, SliceDeleteQuery } from '../api/api.defs';
import { HoursOfOperationRow } from '../app.defs';
import { environment } from 'src/environments/environment';
import { AppointmentRow } from './appointments.defs';
import { Client } from '../clients/client';
import { Inventory } from '../inventory/inventory';
import { Appointment } from './appointment';
import { map } from 'rxjs/operators';
import { SettingsService } from '../settings/settings.service';
import { ClientsService } from '../clients/clients.service';
import { OfflineService } from '../api/offline.service';

@Injectable({
	providedIn: 'root'
})
export class AppointmentsService {

	constructor(
		private _api: ApiService,
		private _settings: SettingsService,
		private _clients: ClientsService,
		private _offline: OfflineService,
	) { }

	save(appt: Appointment, client: Client | {name: string, number: string}, services: Inventory[], repeatDays?: number) {

		console.log('save', {appt, client, services})

		const req: any[] = [],
			newClient = !(client instanceof Client),
			existing = this._clients.getByPhone('' + client.number)[0],
			settings = this._settings.active,
			lunchClient = settings.lunchClientRef,
			lunchService = settings.lunchServiceRef,
			isLunch = !!(services.find(s => s.id === lunchService)),
			appSlice = environment.slices.appointments,
			rows = isLunch ?
				[{
					Appointment: appt.date,
					BarberRef: appt.barber.id,
					ClientRef: lunchClient,
					SERVICERef: lunchService,
					any_barber_0: 0,
				}] :
				services.map(service => {
					return {
						Appointment: appt.date,
						BarberRef: appt.barber ? appt.barber.id : null,
						ClientRef: newClient ?  {'$_': '1:keys:0'} : client['id'],
						SERVICERef: service.id,
						any_barber_0: appt.anyBarber ? 1 : 0,
					};
			});


		if (newClient && !isLunch) {
			if (!client.number || client.number === settings.noNumber_tel) {
				req.push({keys: [settings.noNumberRef]});
			} else {

				if (existing) {
					// skip creating the number, it already there, just get
					// the response ready for the client name..
					req.push({keys: [existing.customerId]});
				} else {
					// make sure this response lines up with the one outside our
					// outer IF block (see comment a few lines down)
					req.push(
						{'!/slice/xinsert': {
							slice: environment.slices.customers,
							rows: [{NUMBER: client.number}]
						}});
				}
			}
			// this injects the CLIENT NAME row, backreference to the CUSTOMER NUMBER
			req.push({'!/slice/xinsert': {
					slice: environment.slices.clients,
					rows: [{NUMBERRef: {'$_': '0:keys:0'}, Name: client.name}]
				}}
			);
		}

		if (appt.children) {
			const ids = appt.children.map(child => child.id);			
			req.push({'!/slice/xdelete': {
				slice: appSlice,
				pkeys: ids,
			}});
		}

		if (appt.id) {
			req.push({'!/slice/xdelete': {
				slice: appSlice,
				pkeys: [appt.id],
			}})
		}

		if (repeatDays) {
			for (let j = 0, jj = rows.length; j < jj; ++j) {
				const r = Object.assign({}, rows[j]);
				for(let i = 1; i < 7; ++i) {
					const tmp = Object.assign({}, r),
						at = new Date(tmp.Appointment);
					at.setDate(at.getDate() + (repeatDays * i));
					tmp.Appointment = at;
					rows.push(tmp);
				}
			}
		}
		
		req.push(
			{'!/slice/xinsert': {
				slice: appSlice,
				rows: rows,
			}},
			{'$_': '*'}
		);

		console.log('request', req);
		return this._api
			.request({'$/tools/action_chain': req})
			.pipe(
				map(resp => {
					console.log('resp', resp);
					return true;
				})
			)
	}

	delete(id: number) {
		return this._api.request<SliceDeleteQuery>({'$/slice/xdelete': {
			slice: environment.slices.appointments,
			pkeys: [id],
		}})
	}

	update(appt: AppointmentRow) {
		return this._api.request<SliceUpdateQuery>({'$/slice/xupdate': {
			slice: environment.slices.appointments,
			rows: [appt],
		}})
	}

	byWeekday(date: Date) {
		const weekday = date.getDay(),
			key = `appointments.byWeekday.${this._offline.dateAsString(date)}`;

		return this._api.request<{
			hours: SliceQuery<HoursOfOperationRow>,
			shifts: SliceQuery<any>,
			appointments: SliceQuery<AppointmentRow>
		}>({
			hours: {'$/slice/report': {slice: environment.slices.hours, fields: {weekday: 'weekday', open: 'open', close: 'close'}, where: {'weekday': weekday}}},
			shifts: {'$/slice/report': {
				slice: 51463,
				fields: {'*': '*', '_available': 'STATUS:available_0'},
				where: ['$eq', ['$date', ['$field', 'START']], ['$date', date]],
				order: [['$field', 'barber']]
			}},
			appointments: {'$/slice/report': {
				slice: environment.slices.appointments,
				where: ['$eq', ['$date', ['$field', 'Appointment']], ['$date', date]],
				order: [['$field', 'Appointment']]
			}},
		}, key);
	}
}
